module.exports = __webpack_public_path__ + "static/media/full-cup-experience-og.2169b62d.png";